import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './Labels.scss';

export function Labels(): JSX.Element {
  useStyles(s);
  const { lesson$: lesson, lessonPageIndex$: lessonPageIndex } = useContainerData(SlLEContext, SlDataService, [
    'lesson$',
    'lessonPageIndex$',
  ]);
  const labels = lesson?.children?.[lessonPageIndex - 1]?.materialInfo?.header?.labels || [];

  return labels?.length ? (
    <div className="le-lesson-labels">
      {labels.map((label) => (
        <div className="le-lesson-labels__label" key={label?.name}>
          {label?.name}
        </div>
      ))}
    </div>
  ) : null;
}
